import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Box, Text, Button } from '@components/common';
import { MobileContainer, DesktopContainer } from '@containers/layout';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import AdjustBoardView from './AdjustBoardView';

const DesktopWrapper = styled(DesktopContainer)`
  @media screen and (max-width: 767px) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
`;

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;
  z-index: 100;
  @media screen and (max-width: 767px) {
    flex: 0;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    padding-top: 0px;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

const MobileOnly = styled(Box)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: none;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const DesktopOnly = styled(Box)`
  width: 100%;
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: block;
  }
  @media screen and (min-width: 1024px) {
    display: block;
  }
`;

function AddonRecurring(props) {
  const { onSubmit, isValidReschedule, skipItem, rescheduleInfo } = props;

  const { week: rescheduleWeek, day: rescheduleDay } = rescheduleInfo || {
    week: 2,
    day: 5
  };

  const handleSkip = () => {
    skipItem(+rescheduleWeek - 1, +rescheduleDay - 1);
    onSubmit();
  };

  return (
    <DesktopWrapper>
      <MobileOnly>
        <Button
          my={2}
          width={1}
          variant="secondary"
          type="button"
          onClick={handleSkip}
        >
          Skip service
        </Button>
        <Button
          my={2}
          width={1}
          type="button"
          disabled={!isValidReschedule}
          onClick={onSubmit}
        >
          Continue
        </Button>
      </MobileOnly>
      <AdjustBoardView flex={1} />
      <ContainerView>
        <Box position="relative" pt={[4, 0]}>
          <Text px={2} mb={4} textAlign={['center', 'left']}>
            One of the dates selected is unavailable. After this cycle of
            services, your schedule will proceed as planned.
          </Text>

          <Text px={2} mb={4} textAlign={['center', 'left']}>
            Please select a different date or skip this service.
          </Text>
        </Box>
        <DesktopOnly>
          <Button
            my={2}
            width={1}
            variant="secondary"
            type="button"
            onClick={handleSkip}
          >
            Skip service
          </Button>
          <Button
            my={2}
            width={1}
            type="button"
            disabled={!isValidReschedule}
            onClick={onSubmit}
          >
            Continue
          </Button>
        </DesktopOnly>
      </ContainerView>
    </DesktopWrapper>
  );
}

AddonRecurring.propTypes = {
  skipItem: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  isValidReschedule: PropTypes.bool,
  rescheduleInfo: PropTypes.object
};

const mapStatesToProps = state => ({
  isValidReschedule: ScheduleSelectors.selectIsValidReschedule(state),
  rescheduleInfo: ScheduleSelectors.selectRescheduleInfo(state)
});

const mapDispatchToProps = dispatch => ({
  skipItem: (row, col) =>
    dispatch(
      ScheduleActions.attachSkipInfoToItem({
        row,
        col
      })
    )
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(AddonRecurring);
